import { action, makeObservable, observable } from "mobx";

export class ProjectPermissionsModel {
    @observable showTour: boolean = false;

    constructor() {
        makeObservable(this);
        this.showTour = false;
    }

    @action
    toggleShowTour = () => {
        this.showTour = !this.showTour;
    };

    tourText = ():string => {
        return this.showTour ? "Hide the tour":"Take the tour";
    }
}